module.exports = __webpack_public_path__ + "static/media/received.f29a64af.svg";